import { APP_LOCALES } from '@hub/common';
import type { AppLocales } from '@hub/common';

export const defaultLocale = 'en-US' as const satisfies AppLocales;

export const appLocales: readonly AppLocales[] = APP_LOCALES;

export const languageNames: Record<AppLocales, string> = {
  'en-US': 'English (US)',
  'nl-NL': 'Nederlands',
  'fr-FR': 'Français',
} as const;
